import { useQuery } from "@tanstack/react-query";
import { cardImageCache } from "@/services/card-image-cache";
import { useEffect } from "react";
import { getSixToKingDeck } from "@shared/game-rules";

export function useOpponentDeck(opponentId: number | null) {
  // If no opponent ID, or if it's not a valid number, don't run the query
  const enabled = opponentId !== null && opponentId !== undefined && !isNaN(opponentId);
  
  const query = useQuery({
    queryKey: ["opponent-default-deck", opponentId],
    queryFn: async () => {
      if (!opponentId || isNaN(opponentId)) {
        throw new Error("Invalid opponent ID");
      }
      
      const response = await fetch(`/api/deck/user-default-deck/${opponentId}`);
      if (!response.ok) throw new Error("Failed to fetch opponent's default deck");
      
      const data = await response.json();
      return data;
    },
    enabled,
    // Use a stale time to prevent frequent refetching
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  // Preload all deck images when the deck data is available
  useEffect(() => {
    if (query.data?.deckUrl) {
      // Get the standard deck of cards
      const cardDeck = getSixToKingDeck();
      
      // Preload all card images for this deck
      cardImageCache.preloadDeckImages(query.data.deckUrl, cardDeck);
    }
  }, [query.data?.deckUrl]);
  
  return query;
}